const toggleSearch = () => {
    const header = document.querySelector('.header');
    if(header){
        const search = header.querySelector('.header__search');
        const btnSearch = search.querySelector('[data-js-header-search-toggle]');
        const body = document.querySelector('body');
        const targets =[body,search,btnSearch];
        const classes = ['overflow-hidden','search-active','btn-search--open'];
        const input = search.querySelector('input[type="text"]');
        const viewsForm = search.querySelector('.views-exposed-form')
        btnSearch.addEventListener('click',() => {
            for(let i = 0; i < targets.length; i++){
                    targets[i].classList.toggle(`${classes[i]}`)
            }
            if(search.classList.contains('search-active')){
                viewsForm.classList.remove('views-form--focused');
                input.value = "";
            }
        })
        viewsForm.addEventListener('click',(e)=> {
            if(e.target != input) {
                viewsForm.classList.remove('views-form--focused');
            }
        })
        input.addEventListener('keydown',(e) => {
            setTimeout(()=>{
                viewsForm.classList.add('views-form--focused');
            },100)
        })
    }
}

toggleSearch();
